export enum CtMessageSize {
    large = 'large',
    tall = 'tall'
}

export enum CtMessageStyle {
    unicolor = 'unicolor',
    multicolor = 'multicolor'
}

export enum CtMessageType {
    success = 'success',
    error = 'error',
}

export enum CtMessageVisualization {
    float = 'float',
    block = 'block'
}